// Enlaces externos del producto (una sola fuente de verdad).
export const APP_STORE_ID = "6790569225";
export const APP_STORE_URL = `https://apps.apple.com/app/lightning-pos/id${APP_STORE_ID}`;
export const GOOGLE_PLAY_PACKAGE = "tf.lightningnetwork.pos";
export const GOOGLE_PLAY_URL = `https://play.google.com/store/apps/details?id=${GOOGLE_PLAY_PACKAGE}`;
export const WEB_POS_URL = "https://pos.lightningnetwork.tf";
export const WEB_POS_DEMO_URL = `${WEB_POS_URL}/demo`;
